import * as React from "react";
import { Route, Switch } from "react-router-dom";
import asyncComponent from "app/asyncComponent";
import Summary from "./Ops.Users.Summary";
import Payments from "./Ops.Users.Payments";
import WalletWithdrawals from "./Ops.Users.Withdrawals";
import List from "./Ops.Users.List";
import LinkedUsers from "./Ops.Users.LinkedUsers";
import Events from "./Ops.Users.Events";
import RecurringPaymentSchedules from "./Ops.Users.RecurringPaymentSchedules";
import Verification from "./Ops.Users.Verification";

const Graph = asyncComponent(() => import("./Ops.Users.Graph"));
const Map = asyncComponent(() => import("./Ops.Users.Map"));

const Users = (props) => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/ops/users"
      render={() => <List {...props} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/users/:id/summary"
      render={(routerProps) => <Summary {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/users/:id/payments"
      render={(routerProps) => <Payments {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/users/:id/withdrawals"
      render={(routerProps) => (
        <WalletWithdrawals {...{ ...props, ...routerProps }} />
      )}
    />
    <Route
      exact={true}
      path="/snapscan/ops/users/:id/linked_users"
      render={(routerProps) => (
        <LinkedUsers {...{ ...props, ...routerProps }} />
      )}
    />
    <Route
      exact={true}
      path="/snapscan/ops/users/:id/recurring_payment_schedules"
      render={(routerProps) => (
        <RecurringPaymentSchedules {...{ ...props, ...routerProps }} />
      )}
    />
    <Route
      exact={true}
      path="/snapscan/ops/users/:id/events"
      render={(routerProps) => <Events {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/users/:id/graph"
      render={(routerProps) => <Graph {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/users/:id/map"
      render={(routerProps) => <Map {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/users/:id/verification"
      render={(routerProps) => (
        <Verification {...{ ...props, ...routerProps }} />
      )}
    />
  </Switch>
);

export default Users;
